// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container_3eNl0","me":"Card_me_1HZ36","icon":"Card_icon_kqxVK","name":"Card_name_30qpQ","introduce":"Card_introduce_1OxfM"};